/** @jsx jsx */
import { Box, Flex } from "@eworkit/iris";
import { FC, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { jsx } from "theme-ui";

import { TimeReport, TimeReportAggregateReturn, TimeReportProject, useTimeReportAggregate } from "@/data/time-reports";

import { TimeReportProjectSingleSelect } from "../projects/TimeReportProjectSingleSelect";
import { TimeReportSpecificationDay } from "./_components/TimeReportSpecificationDay";

interface TimeReportSpecificationProps {
  timeReport: TimeReport;
  aggregateData: TimeReportAggregateReturn;
  editable?: boolean;
}

export const TimeReportSpecification: FC<TimeReportSpecificationProps> = ({ timeReport, aggregateData, editable }) => {
  const { t } = useTranslation("session");

  const [selectedProject, setSelectedProject] = useState<TimeReportProject>();

  const filteredAggregateData = useTimeReportAggregate(timeReport, {
    from: new Date(timeReport.startDate),
    to: new Date(timeReport.endDate),
    filterProjects: selectedProject && (p => p.project.guid === selectedProject.project.guid),
    filterEmptyItems: true,
  });

  const nonEmptyProjects = useMemo(() => aggregateData.projects.map(p => p.project), [aggregateData]);

  return (
    <Flex flexDirection="column" gap="md">
      {aggregateData.projects.length > 1 && (
        <Box sx={{ width: ["100%", null, "250px"] }}>
          <TimeReportProjectSingleSelect
            size="md"
            placeholder={t("TIME_REPORTS.PROJECTS.ALL_PROJECTS")}
            options={nonEmptyProjects}
            value={selectedProject}
            onChange={setSelectedProject}
          />
        </Box>
      )}

      <Flex flexDirection="column" gap="lg">
        {filteredAggregateData.days.map(day => (
          <TimeReportSpecificationDay
            key={day.date.toISOString()}
            date={day.date}
            dayAggregateData={day}
            editable={editable}
          />
        ))}
      </Flex>
    </Flex>
  );
};
